import { FragmentDefiner, useReadFragment } from "../../../GlobalHooks/useReadFragment";

export interface TypologiesProps {
	id: string;
	grid?: { xs: number; sm: number; md: number; lg: number; xl: number; xxl: number };
}

export const useTypologies = ({ id }: TypologiesProps) => {
	const { loading, data, error } = useReadFragment(FRAGMENT_TYPOLOGIES, id);

	return {
		data: data?.project[0]?.typologies,
		loading,
		error,
	};
};

export const FRAGMENT_TYPOLOGIES = new FragmentDefiner(
	"Property",
	`
	project {
        typologies{
            count
            bathrooms
            bedrooms
            price {
              amount
              currency {name}
			}
			m2
			common_expenses{
				amount
				currency {name}
			}
        }
    }
`
);
